import axios from 'axios';
import AppConfig from "../../../../AppConfig";
import LogowanieService from "../../../logowanie/LogowanieService";

let URL = AppConfig.HOST_API() + 'bilety/';
let URL_CLIENT = AppConfig.HOST_CLIENT_API();

export default {

    getBilety() {
        return axios({
            method: 'get',
            url: URL,
        });
    },

    szukajBiletow(dataod, datado, trasa, godz,czyDataSprzedazy,czyPokazywacAnulowaneOperator=true) {

        let url = URL + 'szukaj?dataOd=' + dataod + '&dataDo=' + datado

        if (Boolean(trasa)) {
            url = url + '&idTr=' + trasa
        }

        if (Boolean(godz)) {
            url = url + '&godz=' + godz.replace(':', '.')
        }

        url=url + "&czyPokazywacAnulowaneOperator="+czyPokazywacAnulowaneOperator

        url = url + "&dataSprzedazy="+czyDataSprzedazy

        return axios({
            method: 'get',
            url: url
        });
    },

    addBilet(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editBilet(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteBilet(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    editStatusWJednorazowym(id, val) {
        return axios(
            {
                url: URL + 'status/' + id + '?status=' + val+'&idUz='+LogowanieService.pobierzZalogowanego().idUz,
                method: 'put',
            }
        )
    },

    editGodzinaWJednorazowym(id, val) {
        return axios(
            {
                url: URL + 'godzina/' + id + '?idKu=' + val+'&idUz='+LogowanieService.pobierzZalogowanego().idUz,
                method: 'put',
            }
        )
    },

    editIloscWJednorazowym(idBp,ile){
        return axios(
            {
                url: URL + 'updateIlosc?idBp=' + idBp+'&ile='+ile,
                method: 'put',
            }
        )
    },

    szukajBiletuPoKodzieZParagonu(kod){
        return axios({
            method: 'post',
            url: URL + 'biletKierowca/szukaj',
            data: JSON.stringify({kod:kod}),
        });
    },

    pokazLogiBiletuPoId(idBi){
        return axios({
            method: 'get',
            url: URL + 'biletKierowca/logi/'+idBi,
        });
    },

    zamienParagonNaFakture(obj){
        return axios({
            method: 'post',
            url: URL + 'zamianaNaFakture',
            data: JSON.stringify(obj),
        });
    },




    // MIESIECZNE


    zamienParagonNaFaktureBiletMiesieczny(obj) {
        return axios({
            method: 'post',
            url: URL+'pZamianaPnNaFkBiletMies',
            data: JSON.stringify(obj),
        });
    },

    szukajBiletowMiesiecznych(params) {
        return axios({
            method: 'get',
            url: URL + 'miesieczne/szukaj?' + params
        });
    },
    addBiletMiesieczny(data) {
        return axios({
            method: 'post',
            url: URL + 'miesieczne',
            data: JSON.stringify(data),
        })
    },
    editBiletMiesieczny(id, data) {
        return axios(
            {
                url: URL + 'miesieczne/' + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteBiletMiesieczny(id) {
        return axios(
            {
                url: URL + 'miesieczne/' + id,
                method: 'delete',
            }
        )
    },

    edytujStatusMiesiecznego(idBm, status) {
        return axios({
            url: URL + 'miesieczne/changeStatus/' + idBm + '/' + status,
            method: 'put',
        //    data: JSON.stringify({statBil:status}),
        })
    },

    pobierzFormyPlatnosci(){
        return axios({
            method: 'get',
            url: URL + 'formyPlatn'
        });
    },

    pobierzInformacjeDoFaktury(idBm){
        return axios({
            method: 'get',
            url: URL + 'miesieczne/fkDane/'+idBm
        });
    },

    szukajPlatnosciTPAY(emailLubKodEBUSLubKodTPay){
        return axios({
            method: 'get',
            url: URL + 'platnosci?searchString='+emailLubKodEBUSLubKodTPay+'&page=0&size=9999'
        });
    },

    // DRUK PARAGONU PO ZAKUPIE MSC

    wydrukujParagonPoZakupieMiesiecznego(idUzytkownika,idBiletu){
        return axios({
            method: 'get',
            url: URL + 'miesieczne/drukujParagon/'+idUzytkownika+'/'+idBiletu
        });
    },

    // POBRANIE LUB ZOBACZENIE FAKTURY PO ZAKUPIE BILETU MIESIECZNEGO

    pobierzLubPokazFaktureZaBiletMiesieczny(idBm,czyPobrac){
        return axios({
            method: 'get',
            url: URL_CLIENT + 'auth/faktury/generujFakture/biletMiesieczny/'+idBm +'?download='+czyPobrac,
            responseType: 'blob'
        });
    },


    // gdy operator chce zmienić status biletu to trzeba wiedzieć na jakie moze zmienić

    zapytajoDostepneDoZmianyStatusyBiletu(idBp){
        return axios({
            method: 'get',
            url: URL + 'pJakiStatusOperator?idBp='+idBp
        });
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyApi/BiletyService.js